module.exports = __webpack_public_path__ + "static/media/sla-notExpired.3d9a65b7.svg";